// modules/drag-scroll-comparison.js

/**
 * Drag-to-scroll per tabelle comparative
 * Ottimizzato con requestAnimationFrame per la massima fluidità
 * 
 * - Attiva il drag-to-scroll su qualsiasi elemento con classe 👉  `.js-drag-scroll`
 * - Gestisce correttamente il rilascio del drag e l'inizio di un nuovo drag
 * 
 * CSS utile:
 * file src/sass/theme/componenti/_tabella_comparativa_aziendale.scss
 */

export const initDragScrollComparison = () => {

    const sliders = document.querySelectorAll('.js-drag-scroll');
    
    if (sliders.length === 0) return;

    sliders.forEach(slider => {
        let isDown = false;
        let startX;
        let scrollLeft;
        let velX = 0;
        let momentumID;

        // Funzione per animare lo scroll in modo fluido
        const updateScroll = () => {
            if (!isDown) return;
            slider.scrollLeft = scrollLeft - velX;
            momentumID = requestAnimationFrame(updateScroll);
        };

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('is-dragging');
            
            // Punto di partenza del mouse relativo al contenitore
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            
            cancelAnimationFrame(momentumID);
            updateScroll();
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('is-dragging');
            cancelAnimationFrame(momentumID);
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('is-dragging');
            cancelAnimationFrame(momentumID);
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            
            const x = e.pageX - slider.offsetLeft;
            // Moltiplicatore velocità (2x) per un feedback più reattivo
            velX = (x - startX) * 2;
        });
        
        // Supporto per rotella mouse verticale -> scroll orizzontale
        // slider.addEventListener('wheel', (e) => {
        //     // Se lo scroll è prevalentemente verticale (deltaY), lo trasformiamo in orizzontale
        //     if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        //         e.preventDefault();
        //         slider.scrollLeft += e.deltaY;
        //     } else if (e.deltaX !== 0) {
        //         // Supporto nativo per scroll orizzontale (es. trackpad o mouse con shift)
        //         e.preventDefault();
        //         slider.scrollLeft += e.deltaX;
        //     }
        // }, { passive: false });
    });
};
